/* LA PREUVE CLIENT SOUS LE BOUTON D'ACHAT : un avis, la note, un lien vers le bloc complet.
 *
 * ⛔ LE BLOC NAIT MASQUE ET NE S'OUVRE QUE S'IL A QUELQUE CHOSE A DIRE. Une carte vide sous le
 * bouton d'achat vaut moins que pas de carte : elle occupe la place et ne prouve rien.
 *
 * ⛔ AUCUN TEXTE D'AVIS N'EST ECRIT ICI, ET AUCUN N'EST POSE EN HTML. Le texte vient du Studio,
 * qui le tient de Junip et le traduit ; il passe par textContent.
 *
 * ⛔ LE HREF RESTE `#avisline`, POUR QUI N'A PAS DE JAVASCRIPT. Mais on ne le laisse pas faire
 * le trajet : `scroll-behavior:smooth` rend le saut natif annulable, et il EST annule juste
 * apres l'arrivee sur la fiche, au moment ou le client clique. Voir `versLesAvis` plus bas.
 */
(function () {
  'use strict';
  var bloc = document.querySelector('[data-pdp-avis]');
  if (!bloc || bloc.dataset.arme === '1') return;
  bloc.dataset.arme = '1';

  var BASE = 'https://runway.dcomdtf.app';
  var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();

  /* ⛔ TOUT CE QUI EST CHERCHE DANS LE BLOC PEUT MANQUER, ET LE 19/08/2026 CELA EST ARRIVE. Le
   * snippet a ete deploye avant son script : l'ancien code cherchait les etoiles de la carte,
   * que le nouveau HTML ne portait plus, et l'exception partait dans le `.catch` du fetch. Le
   * bloc restait masque, sans une ligne dans la console. Un theme se deploie fichier par fichier :
   * pendant quelques minutes, le HTML et le JS ne sont pas de la meme generation. */
  function etoiles(hote, note) {
    if (!hote) return;
    /* Cinq etoiles pleines ou vides plutot qu'un demi-caractere : une demi-etoile dessinee au
       texte tombe faux selon la police, et la note chiffree est juste a cote. */
    var arrondi = Math.round(Number(note) || 0);
    hote.textContent = '';
    for (var i = 1; i <= 5; i += 1) {
      var s = document.createElement('span');
      s.className = 'pdp-avis__etoile' + (i <= arrondi ? ' est-pleine' : '');
      s.textContent = '★';
      hote.appendChild(s);
    }
  }

  /* ⛔ UN AVIS TIRE AU SORT A CHAQUE PAGE (Adrien, 19/08/2026 : « pour eviter qu'on ait toujours
   * le meme sur les fiches produit »). Le Studio rend TOUS les avis a cinq etoiles qui tiennent
   * dans la carte ; le tirage se fait ici, et c'est ce qui le rend possible : la reponse est
   * mise en cache un quart d'heure des deux cotes, donc un tirage fait au serveur serait fige
   * pour tout le monde et les mille fiches montreraient le meme avis. */
  var avis = [], position = 0, animation = null, ignorerClicAvant = 0;
  var carte = bloc.querySelector('.pdp-avis__carte');
  var fleches = bloc.querySelectorAll('[data-avis-direction]');

  var delaiAuto = 6000, minuterie = null, survole = false, focusDansBloc = false, appuye = false;
  var enVue = !window.IntersectionObserver;
  var mouvementReduit = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function peutDefiler() {
    return avis.length > 1 && !bloc.hidden && bloc.isConnected !== false && enVue
      && !document.hidden && !survole && !focusDansBloc && !appuye
      && !(mouvementReduit && mouvementReduit.matches);
  }
  function programmer() {
    if (minuterie !== null) clearTimeout(minuterie);
    minuterie = null;
    if (!peutDefiler()) return;
    minuterie = setTimeout(function () {
      minuterie = null;
      if (peutDefiler()) defiler(1, true);
    }, delaiAuto);
  }
  bloc.addEventListener('pointerenter', function (e) {
    if (e.pointerType === 'touch') return;
    survole = true; programmer();
  });
  bloc.addEventListener('pointerleave', function () { survole = false; programmer(); });
  bloc.addEventListener('focusin', function () { focusDansBloc = true; programmer(); });
  bloc.addEventListener('focusout', function (e) {
    focusDansBloc = !!(e.relatedTarget && bloc.contains(e.relatedTarget));
    programmer();
  });
  bloc.addEventListener('pointerdown', function () { appuye = true; programmer(); });
  function relacher() {
    if (!appuye) return;
    appuye = false; programmer();
  }
  document.addEventListener('pointerup', relacher, { passive: true });
  document.addEventListener('pointercancel', relacher, { passive: true });
  document.addEventListener('visibilitychange', programmer);
  if (mouvementReduit && mouvementReduit.addEventListener) mouvementReduit.addEventListener('change', programmer);
  if (window.IntersectionObserver) {
    new window.IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .5;
      if (visible === enVue) return;
      enVue = visible; programmer();
    }, { threshold: .5 }).observe(bloc);
  }


  function afficherAvis(direction) {
    var v = avis[position];
    if (!v) return;
    var texte = bloc.querySelector('[data-avis-texte]');
    var nom = bloc.querySelector('[data-avis-nom]');
    if (texte) texte.textContent = v.texte;
    if (nom) nom.textContent = v.nom || '';
    if (animation) animation.cancel();
    if (direction && carte && carte.animate && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
      animation = carte.animate([
        { opacity: .35, transform: 'translateX(' + (direction * 14) + 'px)' },
        { opacity: 1, transform: 'translateX(0)' }
      ], { duration: 220, easing: 'ease-out' });
    }
  }

  function defiler(direction, automatique) {
    if (avis.length < 2) return;
    if (carte) carte.setAttribute('aria-live', automatique ? 'off' : 'polite');
    position = (position + direction + avis.length) % avis.length;
    afficherAvis(direction);
    programmer();
  }

  fleches.forEach(function (bouton) {
    bouton.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      defiler(Number(bouton.dataset.avisDirection));
    });
    bouton.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        e.preventDefault(); defiler(e.key === 'ArrowLeft' ? -1 : 1);
      }
    });
  });

  function poser(d) {
    var candidats = d && Array.isArray(d.vedettes) ? d.vedettes : [];
    avis = candidats.filter(function (v) { return v && typeof v.texte === 'string' && v.texte.trim(); });
    if (!avis.length && d && d.vedette && d.vedette.texte) avis = [d.vedette];
    position = Math.floor(Math.random() * avis.length);
    var v = avis[position];
    var note = d && d.note;
    var total = d && d.total;
    if (!v || !v.texte || !note || !total) return;

    var elTexte = bloc.querySelector('[data-avis-texte]');
    if (!elTexte) return;
    afficherAvis(0);
    bloc.classList.toggle('est-slider', avis.length > 1);
    fleches.forEach(function (bouton) { bouton.hidden = avis.length < 2; });
    /* Une seule rangee d'etoiles, celle de la note d'ensemble : la carte porte un filet. */
    etoiles(bloc.querySelector('[data-avis-etoiles-moy]'), note);

    /* La virgule decimale suit la langue de la page, pas la notre : 4.9 se lit 4,9 en francais
       et 4.9 en anglais, et l'ecrire en dur donnerait tort a l'une des deux. */
    var m = bloc.querySelector('[data-avis-moyenne]');
    if (!m) { bloc.hidden = false; return; }
    try { m.textContent = Number(note).toLocaleString(lang || undefined, { minimumFractionDigits: 1 }); }
    catch (_) { m.textContent = String(note); }

    /* ⛔ PAS DE NOMBRE (Adrien, 19/08/2026 : « on n'en a pas assez pour le moment »). Onze avis
       affiches en clair sous une note de 4,9 disent surtout qu'il y en a onze. La mention de
       verification, elle, vaut la meme chose a onze qu'a mille. Le compte reste calcule cote
       Studio : le jour ou il devient un argument, il ne reste qu'a le reafficher. */
    var cible = bloc.querySelector('[data-avis-total]');
    if (!cible) { bloc.hidden = false; return; }
    cible.textContent = bloc.getAttribute('data-libelle') || '';
    var logo = bloc.getAttribute('data-junip') || '';
    if (logo) {
      var im = document.createElement('img');
      im.src = logo;
      im.alt = 'Junip';
      im.className = 'pdp-avis__junip';
      im.setAttribute('loading', 'lazy');
      cible.appendChild(im);
    }
    bloc.hidden = false;
  }

  /* ⛔ LE TRAJET VIT DANS `global.js`, UNE SEULE FOIS. Trois endroits y menent : ces etoiles-ci,
   * la carte d'avis, et celles sous le titre (`etoiles-produit.js`). Trois copies du meme
   * defilement, c'est trois occasions qu'elles cessent d'arriver au meme endroit, et la premiere
   * a diverger serait celle qu'on ne regarde pas.
   * Le href reste `#avisline` pour qui n'a pas de JavaScript.
   */
  function versLesAvis(e) {
    if (e && e.type === 'click' && carte && carte.contains(e.target) && Date.now() < ignorerClicAvant) {
      e.preventDefault(); return;
    }
    /* ⛔⛔ LE TIROIR D'ABORD (Adrien, 28/08/2026 : « ici aussi ca doit ouvrir le drawer desktop
       et mobile »). Ce badge vit SOUS le bouton d'achat : un saut d'ancre y envoyait le lecteur
       encore plus loin qu'ailleurs, et rien ne le ramenait a son panier a moitie rempli.
       ⚠️ ET C'EST LE MEME TIROIR QUE CELUI DES ETOILES, pas une seconde copie : deux panneaux
       capables de s'ouvrir ensemble, deux endroits ou remettre le meme noeud d'avis, et la
       premiere a diverger serait celle qu'on ne regarde pas. C'est la lecon deja ecrite ici pour
       le defilement, appliquee au tiroir.
       ⚠️ LE MODIFICATEUR PASSE : un Cmd-clic ou un clic milieu doit ouvrir l'onglet, comme
       n'importe quel lien. */
    if (e && (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1)) return;
    if (typeof window.__avisTiroir === "function" && window.__avisTiroir(e)) return;
    if (typeof window.murVersLesAvis === "function") { window.murVersLesAvis(e); return; }
    /* Sans le module partage, on laisse le lien faire son trajet natif. */
  }

  var lien = bloc.querySelector('[data-avis-lien]');
  if (lien) lien.addEventListener('click', versLesAvis);

  /* ⛔ LA CARTE ENTIERE Y MENE AUSSI (Adrien, 19/08/2026 : « le clic sur la carte doit aussi
   * pointer vers le bloc avis »). Elle montre un avis : cliquer dessus pour en voir d'autres est
   * le geste attendu, et une carte qui a l'air cliquable sans l'etre se paie en clics perdus.
   * ⚠️ ELLE N'EST PAS UN LIEN POUR AUTANT : un `<a>` autour d'une citation ferait un titre de
   * lien illisible pour un lecteur d'ecran, et le vrai lien juste dessous dit deja ou l'on va. */
  if (carte) {
    carte.addEventListener('click', versLesAvis);
    carte.style.cursor = 'pointer';
    var depart = null;
    carte.addEventListener('pointerdown', function (e) {
      depart = e.isPrimary && e.button === 0 && avis.length > 1 ? { x: e.clientX, y: e.clientY, id: e.pointerId } : null;
    });
    carte.addEventListener('pointercancel', function () { depart = null; });
    carte.addEventListener('pointerup', function (e) {
      var debut = depart; depart = null;
      if (!debut || debut.id !== e.pointerId) return;
      var dx = e.clientX - debut.x, dy = e.clientY - debut.y;
      if (Math.abs(dx) < 35 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
      ignorerClicAvant = Date.now() + 400;
      defiler(dx < 0 ? 1 : -1);
    });
  }

  fetch(BASE + '/avis-traductions?lang=' + encodeURIComponent(lang), { credentials: 'omit' })
    .then(function (r) { return r.json(); })
    .then(poser)
    .then(programmer)
    .catch(function (e) {
      /* ⚠️ ON LAISSE UNE TRACE. Le `.catch` muet a cache une exception pendant tout un
         deploiement : le bloc restait vide et rien ne disait pourquoi. */
      if (window.console && console.warn) console.warn('avis-badge :', e && e.message);
    });
})();
